import { useTranslation } from "next-i18next";

import CardUi from "@/components/elements/CardUI";
import { Icon } from "@/components/elements/Icon";
import { SKU_CODES_FOR_BUSINESS_ACCOUNTS } from "@/constants";
import { LINKS } from "@/constants/links";
import { useAccountType } from "@/hooks/useAccountType/useAccountType";
import { useCart } from "@/hooks/useCart";
import useProductDetailsPage from "@/hooks/useProductDetailsPage";
import { isWebshopClosed } from "@/utils/helpers";

import { ProductCardType } from "./types";

export const ProductCard = ({ product }: { product: ProductCardType }) => {
  const { t } = useTranslation();
  const { addItem } = useCart();
  const { isBusinessAccount } = useAccountType();

  const { getInStock, handleRelativePackagingInfoClick } =
    useProductDetailsPage();

  let isProductAvailable = true;

  if (
    SKU_CODES_FOR_BUSINESS_ACCOUNTS.includes(product.skuCode) &&
    !isBusinessAccount
  ) {
    isProductAvailable = false;
  }

  const inStock = getInStock(product.skuCode) && isProductAvailable;

  const handleSizeInfoClick = () => {
    handleRelativePackagingInfoClick(
      product.relativePackaging,
      product.size_original,
      product.size
    );
  };

  return (
    <CardUi as="li">
      <CardUi.BodyMedia
        href={`${LINKS.SHOP}/${product.category.slug}/${product.slug}`}
        imgSrc={product.img}
        imgHover={product.imgHover}
        alt={`${product.title} - ${product.brand.name}`}
      >
        <CardUi.ButtonLeft onClick={handleSizeInfoClick}>
          {t("product_preview_relative_packaging", {
            relativePackaging: Math.round(product.relativePackaging),
          })}
          <Icon type="info" />
        </CardUi.ButtonLeft>

        {isWebshopClosed ? null : (
          <CardUi.ButtonRight
            onClick={() => {
              addItem(
                {
                  id: product.id,
                  price: product.price.price,
                  quantity: 1,
                },
                "products"
              );
            }}
            disabled={!inStock}
          >
            {t(inStock ? "add_CTA" : "out_of_stock_description")}
          </CardUi.ButtonRight>
        )}
      </CardUi.BodyMedia>
      <CardUi.InfoBlock
        topLeft={product.title}
        topRight={product.price.formatted}
        bottomLeft={product.brand.name}
        bottomRight={product.price.litrePrice}
      />
    </CardUi>
  );
};

export type { ProductCardType };
